module.exports = __webpack_public_path__ + "img/marseille.76a9e273.png";